import browser from '../../../../browser';
import expandSvg from '../images/expand.svg';
import resetSvg from '../images/reset.svg';

let expandableContentLabel = 'Expand';

function getExpandButtonContainerElement(domContainer, containerToExpand, ariaControlsId) {
  const onExpandCallback = (button) => {
    /* eslint-disable no-param-reassign */
    const className = 'oc-expandable-content__expanded';
    const icon = button.querySelector('img');

    if (containerToExpand.classList.contains(className)) {
      containerToExpand.classList.remove(className);
      containerToExpand.style.position = 'relative';
      icon.src = expandSvg;
      button.ariaExpanded = false;
    } else {
      containerToExpand.classList.add(className);
      containerToExpand.style.position = 'fixed';
      icon.src = resetSvg;
      button.ariaExpanded = true;
    }
  };

  const expandButtonContainer = browser.document.createElement('div');
  expandButtonContainer.classList.add('oc-expandable-content');

  const labelProp = domContainer?.dataset.expandableContentLabel;
  if (labelProp) {
    expandableContentLabel = labelProp;
  }

  const label = browser.document.createElement('span');
  label.classList.add('oc-expandable-content__button-label');
  label.innerHTML = expandableContentLabel;

  const button = browser.document.createElement('button');
  button.classList.add('oc-expandable-content__button');
  button.ariaExpanded = false;
  button.ariaControls = ariaControlsId;

  const icon = browser.document.createElement('img');
  icon.src = expandSvg;

  button.addEventListener('click', () => onExpandCallback(button));
  button.appendChild(icon);

  expandButtonContainer.appendChild(label);
  expandButtonContainer.appendChild(button);

  return expandButtonContainer;
}

/* istanbul ignore next */
function init(domContainer, containerToExpand, ariaControlsId) {
  const expandButtonContainer = getExpandButtonContainerElement(
    domContainer,
    containerToExpand,
    ariaControlsId
  );

  containerToExpand.insertBefore(expandButtonContainer, containerToExpand.firstChild);
}

export default {
  init,
  getExpandButtonContainerElement,
};
